import { IsEmail, IsNotEmpty, IsPhoneNumber, IsString } from "class-validator";

export class GetSupportPayload {
    @IsString()
    @IsNotEmpty()
    firstName: string;
  
    @IsString()
    @IsNotEmpty()
    lastName: string;
  
    @IsString()
    @IsEmail()
    emailAddress: string;
  
    @IsString()
    @IsPhoneNumber()
    phoneNumber: string;
  
    @IsString()
    @IsNotEmpty()
    jobTitle: string;
  
    @IsString()
    @IsNotEmpty()
    companyName: string;
}